import React, { useState, useEffect } from 'react';
import './ComputerLab.css';
import labImage1 from '../assets/computer (1).webp';
import labImage2 from '../assets/computer (2).webp';
import labImage3 from '../assets/computer (3).webp';
import labImage4 from '../assets/computer (4).webp';

const ComputerLab = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const labImages = [labImage1, labImage2,labImage3,labImage4];

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-slide images every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === labImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? labImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === labImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="complab-container">
       {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>COMPUTER LAB</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Computer Lab</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="complab-main-content">
        <div className="complab-content-wrapper">
          {/* Left Side - Text Content */}
          <div className={`complab-text-content ${isVisible ? 'complab-visible' : ''}`}>
            <h2 className="complab-main-heading">COMPUTER LAB</h2>
            
            <p className="complab-intro-text">
              At Bihani Children's Academy, our cutting-edge computer lab is a cornerstone of our 
              commitment to preparing students for a tech-driven future. The lab is equipped with 
              the latest technology, providing a dynamic environment where students can develop 
              essential digital skills and explore the ever-evolving world of technology.
            </p>

            <div className="complab-feature">
              <h3 className="complab-feature-title">Advanced Hardware:</h3>
              <p className="complab-feature-text">
                Our lab features high-performance computers designed to handle a variety of 
                educational software and applications smoothly, ensuring a seamless learning experience.
              </p>
            </div>

            <div className="complab-feature">
              <h3 className="complab-feature-title">Comprehensive Software Suite:</h3>
              <p className="complab-feature-text">
                We offer a wide range of up-to-date software, including tools for coding, graphic 
                design, digital content creation, and data analysis, aligning with current industry standards.
              </p>
            </div>

            <div className="complab-feature">
              <h3 className="complab-feature-title">High-Speed Internet Access:</h3>
              <p className="complab-feature-text">
                Students benefit from fast and reliable internet, enabling efficient research, 
                collaboration, and online learning activities.
              </p>
            </div>
          </div>

          {/* Right Side - Image Slider */}
          <div className={`complab-image-slider ${isVisible ? 'complab-visible' : ''}`}>
            <div className="complab-slider-container">
              {labImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Computer Lab ${index + 1}`}
                  className={`complab-slider-image ${
                    index === currentImageIndex ? 'complab-active' : ''
                  }`}
                />
              ))}
              
              <button 
                className="complab-slider-arrow complab-arrow-left"
                onClick={handlePrevImage}
              >
                ‹
              </button>
              <button 
                className="complab-slider-arrow complab-arrow-right"
                onClick={handleNextImage}
              >
                ›
              </button>
              
              <div className="complab-slider-dots">
                {labImages.map((_, index) => (
                  <span
                    key={index}
                    className={`complab-dot ${
                      index === currentImageIndex ? 'complab-dot-active' : ''
                    }`}
                    onClick={() => handleDotClick(index)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Additional Features Section */}
        <div className={`complab-additional-section ${isVisible ? 'complab-visible' : ''}`}>
          <div className="complab-feature">
            <h3 className="complab-feature-title">Interactive Learning Environment:</h3>
            <p className="complab-feature-text">
              The lab is designed to support both individual work and group projects, fostering 
              critical thinking, creativity, and teamwork among students.
            </p>
          </div>

          <div className="complab-feature">
            <h3 className="complab-feature-title">Expert Guidance:</h3>
            <p className="complab-feature-text">
              Our knowledgeable instructors are dedicated to guiding students through their digital 
              learning journey, offering support and encouragement to explore new technologies and 
              develop problem-solving skills.
            </p>
          </div>

          <div className="complab-feature">
            <h3 className="complab-feature-title">Extracurricular Programs:</h3>
            <p className="complab-feature-text">
              The computer lab also serves as a hub for extracurricular activities such as coding 
              clubs, tech workshops, and inter-school competitions, nurturing a deeper interest in 
              technology and innovation.
            </p>
          </div>

          <p className="complab-conclusion-text">
            At Bihani Children's Academy, we believe that empowering our students with strong 
            technological skills is crucial for their success in the modern world. Our computer 
            lab is more than just a room with computers; it's a space where ideas come to life 
            and future leaders are shaped.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComputerLab;